import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ModalController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandTimesheetCreateAddPage } from '../cabsand-timesheet-create-add/cabsand-timesheet-create-add';
import { CabsandTimesheetCreatePage } from '../cabsand-timesheet-create/cabsand-timesheet-create';
import { SearchPage } from '../search/search';

@IonicPage()
@Component({
  selector: 'page-cabsand-timesheet-approvals',
  templateUrl: 'cabsand-timesheet-approvals.html',
})
export class CabsandTimesheetApprovalsPage {
  timeSheetList: any = [];
  actionAllowed:boolean = false;
  actiivityCodeList:any = [];

  allFleetList: any = [];
  selectedFilter = "All"
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider,public modalController:ModalController) {
  }
   ionViewDidLoad() {
    this.getScrollData();
  }


  async getScrollData(){
    this.getPermission();
    this.getActivityCodeList();
    this.getTimeSheetData();
    this.gettimeSheetList();
  }

  async getActivityCodeList() {
    this.actiivityCodeList = [];
    let formData: FormData = new FormData();
    formData.append("method_name","activity_code");
    return this.api.post("/tansix_prestart/Activity_code", false,formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          
          this.actiivityCodeList = result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  getCodeName(id){
    let code = "";
    let index = this.actiivityCodeList.findIndex(list_ => list_['id'] == id);
      if(index != -1){
        code = this.actiivityCodeList[index].code;
      }
    return code
  }

  async gettimeSheetList() {
    this.timeSheetList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "search_approver_list");
    if(this.selectedFilter == "All"){
      formData.append("search_job_no", "");

    }else{
      formData.append("search_job_no", this.selectedFilter);

    }
    this.api.post(`/tansix_prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        this.timeSheetList = result.result.result;

      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }


  async getTimeSheetData() {
    let formData: FormData = new FormData();
    formData.append("method_name", "search_job_list_in_approver_list");
    this.api.post(`/tansix_prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
      this.allFleetList = result.result.result;

      }, err => {
        console.log("err", err);
        this.utiltiy.toaster(err.error.message);
      });
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return [...[{"key":"All","value":"All"}],...list];
  }

  async openModalForSearch(list, title, key, value){
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(data);
      if(data){
        this.selectedFilter = data.value;
        this.gettimeSheetList();
      }
    });
    profileModal.present();

  }


  formatAMPM(date) {
    date = date.split(":");
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }

  async acceptRejetc(id) {
    var options = {
      "title": 'Confirmation',
      "message": '',
      "approveText": 'Accept',
      "rejectText": 'Reject',
    };
    let status = await this.utiltiy.attentionDialog(options);
    if (status) {
      this.approveDisaaprove(id, "2", "");
    } else {
      let option = {
        "title": 'Comment',
        "approveText": 'send',
      };
      let comment = await this.utiltiy.inputDialog(option);
      this.approveDisaaprove(id, "4", comment);
      console.log("comment", comment);
    }
    console.log("status", status);
  }

  async approveDisaaprove(id, status, comment) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("timesheet_id", id);
    formData.append("status", status);
    formData.append("comments", comment);
    formData.append("method_name", "approver_timesheet_reject_approve_update_status");
    this.api.post(`/tansix_prestart/timesheet/approver`, true, formData)
      .then((result: any) => {
        console.log("result", result);
        this.utiltiy.stopLoading();
        this.gettimeSheetList();
      }, err => {
        console.log("err", err);
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      });
  }


  updateTimeSheet(prestart){

    this.navCtrl.push(CabsandTimesheetCreateAddPage, { param: prestart,copy:false,approval:true });
  }
  async getPermission(){
    this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-timesheet-create-rw");
   }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-approvals/cabsand-timesheet-approvals.ts